// extracted by css-extract-rspack-plugin
export default {"root":"root-FDkr1Z","desc":"desc-nOtFGT"};